<template>
  <div class="page page-shell">
    <van-nav-bar :title="$t('my.withdraw1')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #right>
        <span class="nav-right" @click="goWithdrawRecord()">
          {{ $t("withdraw.with_record") }}
        </span>
      </template>
    </van-nav-bar>

    <div class="content">
      <div class="hero-card">
        <div class="hero-badge">{{ $t("my.withdraw1") }}</div>
        <div class="hero-title">{{ $t("withdraw.with_money") }}</div>
        <div class="hero-balance">
          {{ $t("my.balance") }} {{ userInfo.money * 1 || 0 }}{{ $t("reservation.unit") }}
        </div>
      </div>

      <div class="info-card">
        <div class="info-row">
          <span class="label">{{ $t("setting.Bankname") }}</span>
          <span class="value">{{ bankinfo || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t("setting.branch_name") }}</span>
          <span class="value">{{ branch_name || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t("setting.bank_code") }}</span>
          <span class="value">{{ bank_code || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t("setting.Banknumber") }}</span>
          <span class="value">{{ bankid || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t("setting.Myname") }}</span>
          <span class="value">{{ username || "-" }}</span>
        </div>
      </div>

      <div class="form-card">
        <div class="field-block">
          <label>{{ $t("withdraw.with_money") }} ({{ $t("reservation.unit") }})</label>
          <div class="money-row">
            <van-field
              v-model="withdraw_money"
              type="number"
              :border="false"
              class="input amount-input"
            />
            <span class="all-btn" @click="allMoeny()">{{ $t("index.all") }}</span>
          </div>
        </div>

        <div class="field-block">
          <label>{{ $t("setting.finance_pwd") }}</label>
          <van-field
            class="input"
            v-model="paypassword"
            type="password"
            :border="false"
          />
        </div>

        <div class="tips-card">
          <div class="tip-line">
            1.{{ $t("withdraw.single_limit") }}{{ $t("withdraw.low") }}
            {{ (withdrawRole.min * 1).toLocaleString() }}{{ $t("withdraw.heigh") }}
            {{ (withdrawRole.max * 1).toLocaleString() }}{{ $t("reservation.unit") }}
          </div>
          <div class="tip-line">
            2.{{ $t("withdraw.with_num") }}{{ withdrawRole.num }}{{ $t("withdraw.number") }}
          </div>
          <div class="tip-line">3.{{ $t("withdraw.with_tip") }}</div>
        </div>
      </div>

      <van-button class="action-btn" type="primary" @click="doWithdraw()">
        {{ $t("withdraw.immediately_withdraw") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.bankinfo = this.$route.query.bankinfo;
    this.bankid = this.$route.query.bankid;
    this.branch_name = this.$route.query.branch_name;
    this.bank_code = this.$route.query.bank_code;
    this.username = this.$route.query.username;
  },
  data() {
    return {
      withdraw_money: "",
      paypassword: "",
      userInfo: {},
      withdrawRole: {},
      bankinfo: "",
      bankid: "",
      branch_name: "",
      bank_code: "",
      username: "",
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    goWithdrawRecord() {
      this.$router.push({ path: "/WithdrawRecord" });
    },
    getUserInfo() {
      return this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserWithdrawRole() {
      return this.$http({
        method: "get",
        url: "user_get_withdraw_role",
      }).then((res) => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw() {
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }
      if (!this.paypassword) {
        this.$toast(this.$t("setting.finance_pwd"));
        return false;
      }
      this.$http({
        method: "post",
        data: { money: this.withdraw_money, paypassword: this.paypassword },
        url: "user_set_withdraw",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.withdraw_money = "";
          this.paypassword = "";
          Promise.all([this.getUserInfo(), this.getUserWithdrawRole()]);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        } else if (res.code === 405) {
          this.$router.push({ path: "/SetPayPassword" });
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

.page-shell {
  min-height: 100%;
  background: linear-gradient(#1a1a1a, #000000) !important;
}

.content {
  padding: 16px;
}

.nav-right {
  color: #f4c57d;
  font-size: 14px;
}

.hero-card {
  padding: 20px;
  border-radius: 18px;
  border: 1px solid #444;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  margin-bottom: 16px;
}

.hero-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 24px;
}

.hero-title {
  margin-top: 12px;
  color: #f4c57d;
  font-size: 36px;
  font-weight: 700;
}

.hero-balance {
  margin-top: 8px;
  color: #fff;
  font-size: 28px;
}

.info-card,
.form-card {
  padding: 16px;
  border-radius: 18px;
  border: 1px solid #2a2a2a;
  background: #141419;
}

.info-card {
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.label {
  color: #8f93a1;
  font-size: 24px;
}

.value {
  color: #fff;
  font-size: 28px;
  word-break: break-all;
}

.field-block {
  margin-bottom: 14px;
}

.field-block label {
  display: block;
  margin-bottom: 8px;
  color: #fff;
  font-size: 26px;
}

.money-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.input {
  border-radius: 14px;
  border: 1px solid #2a2a2a;
  background: #111015;
  padding: 8px 14px;
}

.amount-input {
  flex: 1;
}

::v-deep .input input {
  color: #ccc;
  font-size: 28px;
}

.all-btn {
  flex-shrink: 0;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(244, 197, 125, 0.12);
  border: 1px solid rgba(244, 197, 125, 0.2);
  color: #f4c57d;
  font-size: 24px;
}

.tips-card {
  margin-top: 6px;
  padding: 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.tip-line {
  color: #9ea2b3;
  font-size: 22px;
  line-height: 1.7;
}

.action-btn {
  margin-top: 18px;
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 18px;
  color: #111;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(to right, #f4c57d, #f5a452);
}
</style>
